import firebase from '../../firebase/compat';

const readAloud = async (e, setLoadingReadingAloud) => {

    const question = e.currentTarget.dataset.question;
    if (!question) return;

    setLoadingReadingAloud(true)

     // Base64 → Uint8Array
    const b64ToBytes = (b64) => {
    const bin = atob(b64);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return bytes;
    };

    // Quick header checks: MP3 often starts with "ID3" or 0xFF 0xFB (frame sync)
    const looksLikeMp3 = (bytes) => {
    if (bytes.length < 3) return false;
    const id3 = bytes[0] === 0x49 && bytes[1] === 0x44 && bytes[2] === 0x33; // "ID3"
    const framesync = bytes[0] === 0xff && (bytes[1] & 0xe0) === 0xe0;       // 111xxxxx
    return id3 || framesync;
    };

    try {
        const textToSpeech = firebase.app().functions('europe-west1').httpsCallable('text2Speech');
        const language = e.currentTarget.dataset.language || 'nl';
        const resp = await textToSpeech({ text: question, language });

        const base64 = typeof resp?.data === 'string' ? resp.data : resp?.data?.audioContent;
        if (!base64 || typeof base64 !== 'string') {
        console.error('No base64 audio in response:', resp);
        return;
        }
        // De eigen stem (Piper bij OVH) levert WAV; de functie zegt zelf welk formaat.
        const format = resp?.data?.format || 'wav';
        const mimeType = format === 'mp3' ? 'audio/mpeg' : `audio/${format}`;

        // Remove accidental data URL prefix if the function ever includes one
        const cleaned = base64.replace(/^data:audio\/\w+;base64,/, '');

        const bytes = b64ToBytes(cleaned);
        if (bytes.length < 128) {
        console.error('Audio payload too small:', bytes.length);
        return;
        }
        if (format === 'mp3' && !looksLikeMp3(bytes)) {
        console.warn('Payload does not look like MP3. First bytes:', bytes.slice(0, 8));
        }

        const blob = new Blob([bytes], { type: mimeType });
        const url = URL.createObjectURL(blob);

        const audio = new Audio();
        audio.src = url;
        audio.preload = 'auto';

        // console.log(audio)

        // Optional: check codec support before play
        const canPlay = audio.canPlayType(mimeType);
        if (!canPlay) console.warn(`Browser reports limited/no support for ${mimeType}:`, canPlay);

        await audio.play();
        audio.addEventListener('ended', () => URL.revokeObjectURL(url));
    } catch (err) {
        console.error('TTS/playback failed:', err);
    } finally {
        // Always clear the loading state — otherwise the spinner sticks
        // forever on an error or an early return.
        setLoadingReadingAloud(false)
    }
}

export default readAloud;